import { Box, Stack, Typography } from "@mui/material";

type InvoiceCounterProps = {
    label: string,
    value: number | string,
    color: string;
}

export const InvoiceCounter = ({ label, value, color }: InvoiceCounterProps) => (
    <Box sx={{ textAlign: 'center', minWidth: 75 }}>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5} sx={{ color, opacity: 0.8 }}>
            <Typography variant="caption" sx={{ fontWeight: 800, textTransform: 'uppercase', fontSize: '0.6rem' }}>
                {label}
            </Typography>
        </Stack>
        <Typography variant="body2" sx={{ fontWeight: 900, color: '#1e293b' }}>
            {value}
        </Typography>
    </Box>
);